var _a, _b;
import { MS_PER_DAY, MS_PER_HOUR, MS_PER_MINUTE } from '@progress/kendo-date-math';
import { TABLE_COL_INDEX_ATTRIBUTE, TABLE_ROW_INDEX_ATTRIBUTE, TABLE_PREVENT_SELECTION_ELEMENT } from '@progress/kendo-react-data-tools';
/** The attribute required by the Gantt selection on Gantt `tr` elements. */
export var GANTT_ROW_INDEX_ATTRIBUTE = TABLE_ROW_INDEX_ATTRIBUTE;
/** The attribute required by the Gantt selection on Gantt `td` elements. */
export var GANTT_COL_INDEX_ATTRIBUTE = TABLE_COL_INDEX_ATTRIBUTE;
/** Attribute which disable selection start from this element. */
export var GANTT_PREVENT_SELECTION_ELEMENT = TABLE_PREVENT_SELECTION_ELEMENT;
/** @hidden */
export { MS_PER_HOUR, MS_PER_MINUTE, MS_PER_DAY };
/** @hidden */
export var DEFAULT_DATE = new Date().getTime();
/** @hidden */
export var DAYS_IN_WEEK_COUNT = 7;
/** @hidden */
export var HOUR_DATE_FORMAT = 'hh:mm a';
/** @hidden */
export var DAY_DATE_FORMAT = { skeleton: 'MEd' };
/** @hidden */
export var MONTH_DATE_FORMAT = 'MMM';
/** @hidden */
export var YEAR_DATE_FORMAT = 'yyyy';
/** @hidden */
export var DEFAULT_COLUMN_WIDTH = 100;
/** @hidden */
export var MILESTONE_OFFSET = 6;
/** @hidden */
export var DEPENDENCY_DRAG_HANDLE = 'data-dependency-drag-handle';
/** @hidden */
export var DRAG_DIRECTION_START = 'start';
/** @hidden */
export var DRAG_DIRECTION_FINISH = 'finish';
/** @hidden */
export var DEPENDENCY_DRAG_HANDLE_START_ATT = (_a = {}, _a[DEPENDENCY_DRAG_HANDLE] = DRAG_DIRECTION_START, _a);
/** @hidden */
export var DEPENDENCY_DRAG_HANDLE_FINISH_ATT = (_b = {}, _b[DEPENDENCY_DRAG_HANDLE] = DRAG_DIRECTION_FINISH, _b);
/** @hidden */
export var TASK_ID_ATT = 'data-task-id';
/**
 * @hidden
 */
export var DEFAULT_TASK_MODEL_FIELDS = {
    id: 'id',
    start: 'start',
    end: 'end',
    title: 'title',
    percentComplete: 'percentComplete',
    isRollup: 'isRollup',
    isExpanded: 'isExpanded',
    isInEdit: 'isInEdit',
    children: 'children',
    isSelected: 'isSelected'
};
/**
 * @hidden
 */
export var DEFAULT_DEPENDENCY_MODEL_FIELDS = {
    id: 'id',
    fromId: 'fromId',
    toId: 'toId',
    type: 'type'
};
